import { Permission } from '../../_metronic/helpers/enums'
import { temVinculoMedico, VinculoBase } from '../modules/auth/core/vinculos'

/** Permissões de rota que cada grupo (`usuario.grupo.nome`) recebe. */
export const ROLE_PERMISSIONS: Record<string, Permission[]> = {
  [Permission.Usuario]: [Permission.Usuario],
  [Permission.Employee]: [Permission.Employee, Permission.Usuario],
  [Permission.Admin]: [
    Permission.Employee,
    Permission.Usuario,
    Permission.Admin,
    Permission.SuperGerente,
  ],
  [Permission.SuperAdmin]: [
    Permission.Employee,
    Permission.Usuario,
    Permission.Admin,
    Permission.SuperAdmin,
    Permission.Medico,
  ],
  [Permission.SuperMedico]: [Permission.SuperMedico, Permission.Medico],
  [Permission.Medico]: [Permission.Medico],
  [Permission.SuperGerente]: [Permission.SuperGerente],
  [Permission.Solicitante]: [Permission.Solicitante],
}

export type UsuarioComGrupoEVinculos = {
  grupo?: { nome?: string | null } | null
  vinculos?: VinculoBase[] | null
}

/**
 * Permissões de rota do usuário logado: as do grupo mais `Permission.Medico` para quem tem vínculo
 * médico ativo — o par de `calcularMenuPermissoes` (`useMenuPermissoes.ts`) e o mesmo critério do backend
 * (`principal.isMedicoEmpresa(idEmpresa)`, LO-1409). Sem isso, um ADMIN/EMPLOYEE com vínculo médico via o item "Numeração
 * SNCR" no menu e caía no 404, porque a rota `apps/sncr/*` só aceita `Medico`.
 */
export const calcularRotaPermissoes = (usuario?: UsuarioComGrupoEVinculos | null): Permission[] => {
  const grupo = usuario?.grupo?.nome
  const doGrupo = grupo ? ROLE_PERMISSIONS[grupo] ?? [] : []
  const vinculosAtivos = usuario?.vinculos?.filter((vinculo) => vinculo.ativo)
  if (temVinculoMedico(vinculosAtivos) && !doGrupo.includes(Permission.Medico)) {
    return [...doGrupo, Permission.Medico]
  }
  return doGrupo
}
